<re-captcha
    #captchaRef="reCaptcha"
    siteKey="{{ recaptchaSiteKey }}"
    size="invisible"
    (resolved)="$event && resolvedCaptcha($event)">
</re-captcha>
